import React from "react";

export function EvidenceSelect({ ...rest }) {
  return <div {...rest}>EvidenceSelect</div>;
}
